const rollbarToken = '8839407430f04a44b4a387b02c428a7a';

export default rollbarToken;
